<template>
  <div class="">
    <h2>Chloe’s Terminal</h2>
    <div class="border-2 border-gray-100 ml-10 mt-12 p-8 w-8/12">
      <h3>Device Info</h3>
      <div class="flex justify-end mt-6 items-center">
        <trac-button variant="small">change</trac-button>
      </div>
      <div class="mt-10">
        <p class="text-gray-500">Device name</p>
        <span>Chloe’s Terminal</span>
      </div>
      <div class="mt-10">
        <p class="text-gray-500">Serial Number</p>
        <span>000073839309I4</span>
      </div>
      <div class="mt-10">
        <p class="text-gray-500">Assigned Store</p>
        <span>Ruthies Accesories Store</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
